var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{class:_vm.$vuetify.theme.dark ? undefined : 'grey lighten-4',attrs:{"id":"pages"}},[_c('v-responsive',{staticClass:"d-flex align-left",style:(_vm.styles),attrs:{"min-height":"100vh"}},[_c('router-view')],1),_c('dashboard-core-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }